import { closeEditor, initializeEditor } from './actions';

export const hasInitialized = (state, name) => !!state[name];

export function initializable(name, reducer) {
  const initialState = reducer({}, {});
  return (state = null, action = {}) => {
    switch (action.type) {
      case initializeEditor.toString():
        if (name === action.payload.name) {
          return { ...initialState, ...action.payload.initialState };
        }
        break;
      case closeEditor.toString():
        if (name === action.payload.name) {
          return null;
        }
        break;
      default:
    }

    if (state) return reducer(state, action);
    return state;
  };
}
